import utils from '../utils';
const { isTouchDevice } = utils;

export default () => {

    $('.articles_nav button').click(function(){
		$(this).addClass('is-active').siblings().removeClass('is-active');
		$('.articles_list a').removeClass('is-active');

		if($(this).index() == 4) {
			return
		}

		$('.articles_list .-gr'+($(this).index()+1)).addClass('is-active');
		
	})

	if(!isTouchDevice) {
		$('.articles_list a').hover(function(){
            let offset = 0;
			const index = $(this).parent().index();

            if(index == $('.articles_list li').length -1) {
                offset = -40;
            }

			if(index == 0) {
                offset = 80;
            }

            $('.articles_img').css('top', $(this).parent()[0].offsetTop + 17 + offset + 'px');

			$(this).addClass('is-hover');
			$('.articles_img img').eq($(this).parent().index()).addClass('is-active');
		}, function(){
			$('.articles_list a').removeClass('is-hover');
			$('.articles_img img').removeClass('is-active');
		});
	} else {
        $('body').addClass('touch');
    }
}